import axios from 'axios';

const imageList = [
  'jpg', 'png', 'jpeg'
];
const fileList = ['DOCX', 'DOC', 'PDF', 'docx', 'doc', 'pdf', 'xlsx', 'mp3', 'mp4', 'm4a'];

export async function upload(file, isCompression = true) {
  console.log('file', file);
  const formData = new FormData();
  formData.append('file', file);

  let result = {};
  let url = '';
  let imageUrl = '';
  if (isCompression) {
    // 项目内大多数地方需要有压缩
    imageUrl = axios.defaults.baseMediaURL + '/media/operateAndUpload/1502637b3f2c4288b22e9f04efed60c1?cmd=imageMogr2/thumbnail'; // 有压缩
  } else {
    // 为了支持一些透明图标可能不需要压缩
    imageUrl = axios.defaults.baseMediaURL + '/media/upload/1502637b3f2c4288b22e9f04efed60c1'; // 无压缩
  }
  const fileUrl = axios.defaults.baseMediaURL + '/media/file/upload/1502637b3f2c4288b22e9f04efed60c1';
  const arr = file.name.split('.');
  const suffix = arr[arr.length - 1].toLowerCase();
  if (imageList.includes(suffix)) {
    url = imageUrl;
  } else if (fileList.includes(suffix)) {
    url = fileUrl;
  }
 await axios({
    url: url,
    data: formData,
    method: 'post',
    headers: {
      'Content-Type': 'multipart/form-data'
    },
    timeout: 30 * 1000
  }).then(res => {
    result = res;
    result.name = file.name;
    if (url === fileUrl) {
      result.type = 'myFile';
    }
  }).catch(err => {
    console.log(err);
  });
  return result;
}

export function getFileName(fileName = '') {
  const index = fileName.lastIndexOf('.');
  return fileName.substring(0, index);
}
